import BaseHub, { CloseHandler } from 'api/baseHub';

const events = {
  updated: 'Updated',
};

class TableHub extends BaseHub {
  constructor(onCloseHandler: CloseHandler) {
    super('TableHub', onCloseHandler);

    this.addHandlers = ({ updatedHandler }) => {
      const { updated } = events;

      this.addHandler(updated, updatedHandler);
    };
  }
}

export default TableHub;
